import { cn } from '@/lib/utils';

const FIELDS: { key: string; green?: boolean }[] = [
  { key: 'message_type', green: true },
  { key: 'schema_version' },
  { key: 'source' },
  { key: 'tenant_id' },
  { key: 'aircraft_serial' },
  { key: 'sequence' },
];

/** Lift common header fields into pills. Reads payload.header. */
export function MetaRow({ payload }: { payload: unknown }) {
  const header =
    payload && typeof payload === 'object' && 'header' in payload
      ? (payload as { header: Record<string, unknown> }).header
      : null;

  if (!header || typeof header !== 'object') {
    return (
      <div className="flex min-h-[26px] items-center border-b border-(--color-border) bg-(--color-surface) px-3 py-1">
        <span className="font-sans text-[0.615em] text-(--color-text3)">No header metadata</span>
      </div>
    );
  }

  return (
    <div className="flex min-h-[26px] flex-wrap items-center gap-1 border-b border-(--color-border) bg-(--color-surface) px-3 py-1">
      {FIELDS.map(({ key, green }) => {
        const v = header[key];
        if (v === undefined || v === null) return null;
        const label =
          key === 'schema_version' ? `v${v}` : key === 'sequence' ? `seq:${v}` : String(v);
        return (
          <span
            key={key}
            className={cn(
              'rounded border px-[7px] py-[2px] font-mono text-[0.769em]',
              green
                ? 'border-(--color-green) bg-(--color-green-bg) text-(--color-green)'
                : 'border-(--color-border) bg-(--color-bg) text-(--color-text2)',
            )}
          >
            {label}
          </span>
        );
      })}
    </div>
  );
}
